const WhyChooseSection: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Why Choose J's Landscaping?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Experience the difference of working with Maryland's trusted landscaping professionals
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {/* Feature 1 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-shield-check-line text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Licensed & Insured</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Fully licensed and insured for your complete peace of mind. We protect your property and our team on every job.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-star-fill text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">5-Star Rated Service</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Consistently rated 5 stars by our satisfied customers. Our reputation speaks for itself through hundreds of happy clients.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-time-line text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">9+ Years Experience</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Nearly a decade of professional landscaping expertise. We've seen it all and know how to handle any challenge.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Competitive Pricing</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Fair, transparent pricing with no hidden fees. Get premium quality service without breaking the bank.
            </p>
          </div>

          {/* Feature 5 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-customer-service-2-line text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Exceptional Customer Service</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Responsive communication and personalized attention. We're here to answer your questions and exceed your expectations.
            </p>
          </div>

          {/* Feature 6 */}
          <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4 lg:mb-5">
              <i className="ri-calendar-check-line text-2xl sm:text-3xl lg:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Reliable & On-Time</h3>
            <p className="text-sm sm:text-base text-gray-600">
              We show up when we say we will. Count on us for consistent, dependable service that fits your schedule.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
